/** @jsxImportSource @emotion/react */
import React from "react";
import { Alert, Col, Modal, Row, Button, Typography } from "antd";
import * as Styles from "./styles";
import {
  TenantUserUsecase,
  useTenantUserDispatch,
} from "../../../usecases/TenantUser";
import { GetTenantUserDto } from "../../../services/TenantUser/dto/get.dto";

interface ModalDeleteTenantUserProps {
  onCancel: () => void;
  onSuccess: () => void;
  visible: boolean;
  item: GetTenantUserDto;
}

const ModalDeleteTenantUserComponent: React.FC<ModalDeleteTenantUserProps> = ({
  visible,
  onCancel,
  onSuccess,
  item,
}: ModalDeleteTenantUserProps) => {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const TenantUserDispatch = useTenantUserDispatch();

  const onButtonSubmitClickHandle = React.useCallback(async () => {
    setIsProcessing(true);
    try {
      if (TenantUserDispatch) {
        const tenantUserUsecase = new TenantUserUsecase(TenantUserDispatch);
        await tenantUserUsecase.delete({ id: item.id });
      }
      setErrorMessage("");
      onSuccess();
    } catch (error) {
      console.error(error);
      setErrorMessage(error.message);
    } finally {
      setIsProcessing(false);
    }
  }, [TenantUserDispatch, item.id, onSuccess]);

  const onCancelHandle = React.useCallback(() => {
    setErrorMessage("");
    onCancel();
  }, [onCancel]);

  return (
    <Modal
      title="Delete User"
      visible={visible}
      closable={false}
      footer={[
        <Button key="back" size="large" onClick={onCancelHandle}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          danger
          size="large"
          loading={isProcessing}
          onClick={onButtonSubmitClickHandle}
        >
          Delete
        </Button>,
      ]}
    >
      {errorMessage && (
        <Row justify="center">
          <Col css={Styles.colGutterStyle}>
            <Alert message={errorMessage} type="error" />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <Typography>Are you sure to delete user {item.userEmail}?</Typography>
        </Col>
      </Row>
    </Modal>
  );
};

export const ModalDeleteTenantUser = React.memo(ModalDeleteTenantUserComponent);
